import Immutable from 'seamless-immutable';
import _ from 'lodash';
import ExperienceModel from './experience-model';
import { baseCollection } from '../../common/collections';

/**
 * Transforms and array of backend experience objects into a ExperienceCollection
 * @typedef {Object} Response
 * @param {Object[]} content - backend formatted experiences
 * @param {Object} meta - meta information related to experience
 * @returns {Object} Containing experiences{Experience[]} and count{Number} properties
 */
function deserialize({ content = [], meta: { count } }) {
  return Immutable({
    experiences: _.map(content, ExperienceModel.deserialize),
    count,
  });
}

const create = deserialize;

/**
 * Transforms a ExperienceCollection into an array of backend experience objects
 * @param {Experience[]} experiences
 * @returns {Object[]}
 */
function serialize(experiences) {
  return _.map(experiences, experience => ExperienceModel.serialize(experience));
}

export default {
  ...baseCollection,
  create,
  deserialize,
  serialize,
};
